'use es6';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import classnames from 'classnames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import { isFile } from 'FileManagerCore/utils/FoldersAndFiles';
import { getIsReadOnly } from 'FileManagerCore/selectors/Permissions';
import { getHasAnyFolders } from '../selectors/FoldersAndFiles';
import { openModal } from '../actions/Actions';
import DeleteFileOrFolderButton from './containers/DeleteFileOrFolderButton';
import RenameButton from './RenameButton';
import MoveButton from './MoveButton';
import ManageAccessButton from './ManageAccessButton';
import { getIsFileExternal } from 'FileManagerCore/utils/fileAccessibility';
import { getIsUserSuperAdmin, selectIsUngatedForPermissions } from 'FileManagerCore/selectors/Auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TABLE_ACTIONS_CLASSNAME = 'table-action-buttons';
const TableActionButtons = props => {
  const {
    object,
    hasAnyFolders,
    isReadOnly,
    isUngatedForPermissions,
    isUserSuperAdmin,
    onClickFileDetails,
    shrinkOnHide
  } = props;
  return /*#__PURE__*/_jsxs(UITableHoverContent, {
    className: classnames("no-shrink p-left-4", TABLE_ACTIONS_CLASSNAME),
    shrinkOnHide: shrinkOnHide,
    children: [isFile(object) && /*#__PURE__*/_jsx(UIButton, {
      size: "extra-small",
      use: "tertiary-light",
      onClick: onClickFileDetails,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerDashboard.actions.details"
      })
    }), /*#__PURE__*/_jsx(UIDropdown, {
      buttonSize: "extra-small",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerDashboard.actions.actionsDropdown"
      }),
      "data-test-id": "table-actions-dropdown",
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [!getIsFileExternal(object) && /*#__PURE__*/_jsx(RenameButton, {
          object: object,
          openModal: props.openModal,
          isReadOnly: isReadOnly,
          size: "extra-small"
        }), hasAnyFolders && !getIsFileExternal(object) && /*#__PURE__*/_jsx(MoveButton, {
          object: object,
          isReadOnly: isReadOnly,
          size: "extra-small"
        }), /*#__PURE__*/_jsx(DeleteFileOrFolderButton, {
          fileOrFolder: object,
          size: "extra-small"
        }), (isUngatedForPermissions ? isUserSuperAdmin && !isFile(object) : !isFile(object)) && /*#__PURE__*/_jsx(ManageAccessButton, {
          folder: object
        })]
      })
    })]
  });
};
TableActionButtons.propTypes = {
  object: PropTypes.instanceOf(Immutable.Map).isRequired,
  hasAnyFolders: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  onClickFileDetails: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  shrinkOnHide: PropTypes.bool.isRequired,
  isUngatedForPermissions: PropTypes.bool.isRequired,
  isUserSuperAdmin: PropTypes.bool.isRequired
};
TableActionButtons.defaultProps = {
  shrinkOnHide: true
};
const mapStateToProps = state => ({
  hasAnyFolders: getHasAnyFolders(state),
  isReadOnly: getIsReadOnly(state),
  isUngatedForPermissions: selectIsUngatedForPermissions(state),
  isUserSuperAdmin: getIsUserSuperAdmin(state)
});
const mapDispatchToProps = {
  openModal
};
export default connect(mapStateToProps, mapDispatchToProps)(TableActionButtons);